import { useRelocateInventoryObject } from './api.ts'

export const useRelocateInventObject = () => {
  const { relocate: relocateObject } = useRelocateInventoryObject()

  const relocate = async (objects: { object_id: number; coordinates: any }[]) => {
    await relocateObject(objects)
  }

  return {
    relocate,
  }
}
